$(document).ready(function() {
    //cookieText a cookieBtn jsou definovány v layout.latte

    $('body').cookieDisclaimer({
        // top,middle,bottom
        position: "bottom",
        // dark,light
        style: "dark",
        // "bar" and "modal" text
        text: cookieText,
        // accept button options
        acceptBtn: {
            text: cookieBtn // accept btn text
        },
        // policy button options
        policyBtn: {
            active: false
        },

        // jQuery cookie plugin options
        cookie: {
            name: "cookieDisclaimer",
            val: "confirmed",
            path: "/",
            expire: 365
        }
    });
});